import { Component } from '@opten/gin-tonic/helpers/compiler';
import { SwiperItem } from '@opten/gin-tonic/components/swiper';

@Component({className: 'js-gallery'})
export class GalleryComponent {
	private swiper;
	private init = false;

	constructor(private element: HTMLElement) {
		this.initSwiper();
		window.addEventListener('resize', this.initSwiper.bind(this));
	}

	private initSwiper() {
		if(window.innerWidth <= 768) {
			if(!this.init) {
				this.init = true;
				this.swiper = new SwiperItem(this.element, {
					slidesPerView: 1,
					spacing: 10,
					centeredSlides: true,
					navigation: {
						nextEl: '.js-gallery-next',
						prevEl: '.js-gallery-prev',
					},
				});
			}
		} else {
			this.swiper?.destroy();
			this.init = false;
		}
	}
}
